export const SHOWN_BANKS_COUNT = 4;
